import React from "react";
//#region types
import { ButtonGroupProps } from "models/propTypes/menuPropTypes";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import ButtonGroup from "./buttonGroup";
import MenuButton from "./menuButton";
import StyledButton from "./styledButton";
import Icon from "../icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const DashboardButtonGroup: React.FC<ButtonGroupProps> = (props) => {
  const { buttons, moreActions, className } = props;
  return (
    <ButtonGroup
      buttons={
        moreActions && moreActions.length > 0
          ? [
              ...buttons,
              <MenuButton
                menuItems={moreActions}
                menuPlacement="bottom"
                button={
                  <StyledButton size="xs" className={clsx(cssExports.iconButton, cssExports.transparent)}>
                    <Icon icon={IconDefinitionConstants.WEllipsisH} />
                  </StyledButton>
                }
                popperOffSet={[8, 3]}
              />,
            ]
          : buttons
      }
      className={className}
    />
  );
};

export default DashboardButtonGroup;
